import React, { useState } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components/macro";
import { shadow, smallShadow } from "theme/GlobalElements";
import DeliveryInfo from "./DeliveryInfo";
import PersonalInfo from "./PersonalInfo";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "theme/Theme";
import { MdChevronRight } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { device } from "theme/Breakpoints";
import {
  selectCurrentStep,
  setCurrentStep,
  selectCartReload,
} from "../cartSlice";
import { checkout } from "features/payment/paymentSlice";
import userStorage from "store/UserStorage";
import { ProductCartItem } from "../types";
interface DeliveryInformationProps {}

const DeliveryInformation: React.FC<DeliveryInformationProps> = ({}) => {
  const { register, errors, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reload = useSelector(selectCartReload);
  const cartItems = userStorage.getStoredInCart();
  const currentStep = useSelector(selectCurrentStep);

  const onSubmit = (data: any) => {
    const items = cartItems.map((item: ProductCartItem) => {
      return {
        id: item.product._id,
        count: item.count,
        installation: item.installation ?? false,
        objectType: item.product.objectType,
      };
    });

    const orderObj = { ...data, items };
    dispatch(checkout(orderObj));
  };

  const goBack = () => {
    if (currentStep === 1) {
      navigate("/");
    } else {
      dispatch(setCurrentStep(currentStep - 1));
    }
  };

  return (
    <>
      <Helmet>
        <title>Информация за доставка</title>
      </Helmet>
      <DeliveryInformationContainer onSubmit={handleSubmit(onSubmit)}>
        <MainContainer>
          <PersonalInfo register={register} errors={errors} />
          <DeliveryInfo register={register} />
        </MainContainer>
        <Buttons>
          <Button className="back-button text-body" onClick={goBack}>
            <span>Обратно</span>
          </Button>
          <Button type="submit" className="next-step-button text-body">
            <span>Продължи</span>
            <MdChevronRight />
          </Button>
        </Buttons>
      </DeliveryInformationContainer>
    </>
  );
};

const DeliveryInformationContainer = styled.form`
  display: flex;
  flex-flow: column;

  .form-title {
    color: black;
    font-weight: 700;
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

const Buttons = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin: 15px 0;

  @media only screen and (${device.laptop}) {
    margin: 25px 0;
  }
`;

const Button = styled.button`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 5px 10px;
  transition: 0.3s all;
  cursor: pointer;
  ${smallShadow}

  &:nth-child(1) {
    margin-right: 10px;
  }

  &.back-button {
    background-color: white;
    outline: 1px solid ${colors.lighter_blue};
    border: none;
    color: ${colors.lighter_blue};
  }

  &.next-step-button {
    background-color: ${colors.lighter_blue};
    color: white;
  }

  &:hover {
    transform: scale(0.98);
  }

  @media only screen and (${device.laptop}) {
    padding: 10px 20px;
  }
`;

export default DeliveryInformation;
